/**
 * État d'interface du menu principal (jamais envoyé au serveur) : écran affiché, partie
 * sélectionnée, fenêtre ouverte, et les actions fournies par l'amorçage (rejoindre, se
 * déconnecter).
 */
import { signal } from '@preact/signals';
import type { ServerSummary } from '@snowchain/shared';

export type MenuView = 'home' | 'servers' | 'friends';
export type ServerFilter = 'all' | 'friends' | 'mine' | 'invites';
export type FriendsTab = 'friends' | 'requests' | 'recent' | 'blocked';

export type MenuDialog =
  | { k: 'create' }
  | { k: 'code'; code?: string }
  | { k: 'settings'; server: ServerSummary }
  | { k: 'delete'; server: ServerSummary }
  | { k: 'invite'; server: ServerSummary }
  | { k: 'profile' }
  | { k: 'message'; title: string; message: string };

export const menu = {
  view: signal<MenuView>('home'),
  selected: signal<string | null>(null),
  filter: signal<ServerFilter>('all'),
  search: signal(''),
  onlyOpen: signal(false),
  friendsTab: signal<FriendsTab>('friends'),
  dialog: signal<MenuDialog | null>(null),
  /** Partie en cours de chargement (bouton « Rejoindre » désactivé). */
  joining: signal<string | null>(null),
};

/** Actions branchées par main.tsx. */
export const menuActions: {
  join: (worldId: string) => void;
  logout: () => void;
  /** Jeton de session courant (protection du compte invité). */
  token: () => string;
} = {
  join: () => undefined,
  logout: () => undefined,
  token: () => '',
};

export function openServer(id: string): void {
  menu.selected.value = id;
  menu.view.value = 'servers';
}
